import type { Marketplace } from '@/lib/api/schemas/stock-guard.schema'

const marketplaceLabels: Record<Marketplace, string> = {
  wildberries: 'Wildberries',
  'yandex-market': 'Яндекс Маркет',
}

const reasonLabels: Record<string, string> = {
  variant_not_in_registry: 'SKU продавца не найден в реестре',
  ambiguous_variant_match: 'Найдено несколько подходящих товаров',
  counterpart_publication_absent: 'Нет активной публикации на второй площадке',
  counterpart_publication_archived: 'Публикация на второй площадке архивирована',
  barcode_unallocated: 'Для Wildberries не назначен баркод',
  warehouse_unconfigured: 'Склад Wildberries не настроен',
  campaign_unconfigured: 'Кампания Яндекс Маркета не настроена',
  order_line_sku_not_in_registry: 'Строка заказа не сопоставлена с товаром реестра',
}

export function marketplaceLabel(value: Marketplace): string {
  return marketplaceLabels[value]
}

export function guardReasonLabel(value: string | null): string {
  if (value === null) return 'Причина не требуется'
  return reasonLabels[value] ?? 'Причина не распознана'
}
